import React, { Component, useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  FloatingLabel,
  // Input,
  // Label,
} from 'react-bootstrap'; //"reactstrap";
import { useNavigate } from "react-router-dom";
// import Button from 'react-bootstrap/Button';
// import Modal from 'react-bootstrap/Modal';

interface CustomModalProps {
  show: boolean;
  onHide: () => void;
  link?: string;
  children?: React.ReactNode;
  isFooter?: boolean;
}

const WarningModal: React.FC<CustomModalProps> = ({ show, onHide, link, children, isFooter = true }) => { // children
  const navigate = useNavigate();
  // const WarningModal = (props) => {  
  // const [display, setDisplay] = useState(show);
  // constructor(props) {
  //   super(props);
  
  //   this.state = {
  //     activeItem: this.props.activeItem,
  //   };
  //   console.log("ALLONS-Y");
  // }

  // const handleChange = (e) => {
  //   let { name, value } = e.target;

  //   if (e.target.type === "checkbox") {
  //     value = e.target.checked;
  //   }

  //   const activeItem = { ...this.state.activeItem, [name]: value };

  //   this.setState({ activeItem });
  // };

  // const { toggle, onSave } = this.props;
  // const showHideClassName = display ? "block" : "none";

  // const closeModal = () => {
  //   setDisplay(false);
  // }
  const goToLink = () => {
    if (link) {
      navigate(link);
    }
  }
  // console.log('link', link);
  // console.log('link', link ? 'ok' : 'no');
  return (
  //   <div
  //   className="modal show"
  //   style={{ display: display ? "block" : "none", position: 'initial' }}
  // >
  //   <Modal.Dialog className="customModal">
    <Modal
      show={show}
      onHide={link ? goToLink : onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      {/* <Modal.Header closeButton>
        <Modal.Title>Modal title</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>Modal body text goes here.</p>
      </Modal.Body> */}
      {children}

      { isFooter &&
        <Modal.Footer>
          {/* <Button variant="secondary" onClick={closeModal}>Close</Button> */}
          <Button variant="secondary" onClick={link ? goToLink : onHide}>Close</Button>
          {/* <Button variant="primary">Save changes</Button> */}
        </Modal.Footer>
      }
      </Modal>
  //    </Modal.Dialog>
  // </div>
  );
}

export default WarningModal;